import { loadStripe } from '@stripe/stripe-js'

let stripePromise = null

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
  }
  return stripePromise
}

// Tier pricing config — single source of truth
export const TIERS = {
  0: {
    id: 0,
    name: 'Free',
    label: 'Free account',
    description: 'Access to purchased software packages only. No course content.',
  },
  1: {
    id: 1,
    name: 'Foundation',
    price: 1199,
    firstMonthPrice: 999,
    currency: 'eur',
    interval: 'month',
    stripePriceId: null,
    label: '€11.99/mo',
    firstMonthLabel: '€9.99 first month',
  },
  2: {
    id: 2,
    name: 'Entry Level',
    price: 1499,
    firstMonthPrice: 1199,
    currency: 'eur',
    interval: 'month',
    stripePriceId: null,
    label: '€14.99/mo',
    firstMonthLabel: '€11.99 first month',
  },
  3: {
    id: 3,
    name: 'Mid-Level',
    price: 1799,
    firstMonthPrice: 1499,
    currency: 'eur',
    interval: 'month',
    stripePriceId: null,
    label: '€17.99/mo',
    firstMonthLabel: '€14.99 first month',
  },
  4: {
    id: 4,
    name: 'Senior',
    price: 2099,
    firstMonthPrice: 1799,
    currency: 'eur',
    interval: 'month',
    stripePriceId: null,
    label: '€20.99/mo',
    firstMonthLabel: '€17.99 first month',
  },
}

export const BRANCH_UNLOCK_PRICE    = 4499 // €44.99
export const ADD_ON_PRICE           = 2499 // €24.99 — all cert prep and software packages

export const CAREER_TREES = [
  { id: 'infrastructure', label: 'Infrastructure', icon: '🖥️' },
  { id: 'itsm', label: 'ITSM', icon: '🎫' },
  { id: 'cloud', label: 'Cloud', icon: '☁️' },
  { id: 'security', label: 'Security', icon: '🔒' },
  { id: 'data-analytics', label: 'Data & Analytics', icon: '📊' },
]
